import { render } from "./HrApproveAwards.vue?vue&type=template&id=1c7eb73a&scoped=true"
import script from "./HrApproveAwards.vue?vue&type=script&lang=js"
export * from "./HrApproveAwards.vue?vue&type=script&lang=js"

import "./HrApproveAwards.vue?vue&type=style&index=0&id=1c7eb73a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abbas\\Desktop\\kswc\\kswc_dashboard-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c7eb73a"]])

export default __exports__